module.exports = __webpack_public_path__ + "static/Tech-a66d99957f0a3d30fa90cbb4f9852c71.svg";